import { TableCell, TableRow, Typography } from "@mui/material";

export const LogsRow = (log)=>{
    const {type, messageType, time, message, lpId, lpName} = log.data;
    const formatMicroseconds = (timestamp)=> {
        const match = timestamp.match(/\.(\d{6})/);
        if (!match) return fallbackFormat(timestamp);
        
        const microseconds = match[1];
        const fourDecimalPlaces = microseconds.substring(0, 4);
        
        const date = new Date(timestamp);
        const time = date.toLocaleTimeString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        
        return `${time}.${fourDecimalPlaces}`;
    };
    const fallbackFormat = (timestamp)=> {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) + '.0000';
    };
    return (
    <>
        <TableRow
                    sx={{
                        "& .MuiTableCell-root": {
                        borderBottom: "none",
                        px: 1,
                        py: 1.5,
                        },
                        backgroundColor: "primary.main",
                        borderRadius: "4px",
                        "& td:first-of-type": {
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                        borderTopRightRadius: "",
                        borderBottomRightRadius:  "",
                        },
                        "& td:last-child": {
                        borderTopRightRadius:  "6px",
                        borderBottomRightRadius: "6px",
                        borderTopLeftRadius:  "",
                        borderBottomLeftRadius: "",
                        },
                        "&:hover": {
                        backgroundColor: "tertiary.main",
                        },
                    }}
                >
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {formatMicroseconds(time)}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {lpId || '--'}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {lpName || '--'}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {type}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {messageType}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography sx={{ fontSize: '11px' }}>
                        {message}
                        </Typography>
                    </TableCell>                    
        </TableRow>    
    </>) ;
}
